<template>
  <layout-auth>
    <v-container class="py-8">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("invoices.resumenConfirmacionalta") }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <label style="font-size: 18px" class="font-weight-light">
            {{ $t("invoices.datosAnticipos") }}
          </label>
          <h3 class="text-subtitle-1">
            {{ $t("invoices.muestraDatos") }}
          </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <label class="second-type-label"> {{ $t("invoices.nombreEmpresaCliente") }} </label>
          <p class="font-weight-medium text-subtitle-1">{{ model.empresa }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="4" lg="3">
          <label class="second-type-label">{{ $t("invoices.cuentaAbono") }} </label>
          <p class="text-subtitle-1">{{ model.cuenta }}</p>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <label class="second-type-label">{{ $t("invoices.fechaSolicitud") }}</label>
          <p class="text-subtitle-1">{{ model.fecha }}</p>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <label class="second-type-label"> {{ $t("invoices.facturasAnticipar") }}</label>
          <p class="text-subtitle-1">{{ model.factura }}</p>
        </v-col>
      </v-row>
      <v-row class="py-10">
        <v-col cols="12" sm="12" lg="12">
          <v-btn
            v-if="!confirmed"
            depressed
            @click="confirmCreate"
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("users.confirm") }}
          </v-btn>
          <v-btn
            v-else
            depressed
            @click="finalizar"
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("supplierData.finish") }}
          </v-btn>
          <v-btn
            v-if="!confirmed"
            outlined
            @click="goBack"
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("users.goBack") }}
          </v-btn>
          <v-btn
            v-else
            plain
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
            @click="print"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("users.print") }}
          </v-btn>
        </v-col>
        <v-col></v-col>
        <overlay :visible="spinner"></overlay>
      </v-row>
    </v-container>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Api from "../../Services/index";
import Overlay from "../../components/layouts/overlay.vue";

export default {
  components: { LayoutAuth, Overlay },
  data() {
    return {
      confirmed: false,
      spinner: false,
      entityConfig: {},
      model: {
        empresa:
          "APODERADO PRUEBAS EMISOR I RSI ENTIDAD FORMACIÓN EN PRODUCCIÓN",
        cuenta: "ES36 2028 4343 1976",
        fecha: "01 May 2021",
        factura: "Todas las facturas vivas",
      },
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    let autoAdvance = JSON.parse(sessionStorage.getItem("autoAdvance"));
    if (autoAdvance) {
      let date = new Date();
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
      let mo = new Intl.DateTimeFormat("es", { month: "short" }).format(date);
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      this.model.empresa = autoAdvance.numClient.name;
      this.model.cuenta = autoAdvance.iban.iban;
      this.model.fecha = `${da} ${mo} ${ye}`;
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    print() {
      window.print();
    },
    confirmCreate() {
      this.spinner = true;
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let userId = userdata.supplierId.trim();
      let autoAdvance = JSON.parse(sessionStorage.getItem("autoAdvance"));
      let request = {
        iban: this.model.cuenta,
        numClient: autoAdvance.numClient.numClient,
        typeConfirming: 'N',
      };
      Api.post(`/proveedores/${userId}/anticipos-automaticos`, request)
        .then(() => {
          sessionStorage.removeItem("autoAdvance");
          this.$toast.success("Se ha creado un nuevo anticipo automático");
          this.confirmed = true;
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    finalizar() {
      this.$router.push("/anticipo-automatico/consulta");
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
